import routerOptions0 from "/builds/campinginfo/civ2-nuxt-3/node_modules/.pnpm/nuxt@4.1.3_@parcel+watcher@2.5.1_@types+node@24.7.2_@vue+compiler-sfc@3.5.22_db0@0.3.2__31f4ed2e45800c2ee442137ad7b2e45b/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/campinginfo/civ2-nuxt-3/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}